export const LANGUAGE_ZH = "zh-CN";
export const LANGUAGE_EN = "en-US";

export const LANGUAGE_LABELS = {
  [LANGUAGE_ZH]: "中文",
  [LANGUAGE_EN]: "English",
};

export const UI_TRANSLATIONS = {
  "全部项目": "All Projects",
  "项目总览": "Project Overview",
  "本集剧本": "Episode Script",
  "分镜编辑器": "Shot Editor",
  "故事板导演台": "Storyboard Director",
  "小故事板": "Mini Storyboard",
  "画布模式": "Canvas Mode",
  "粗剪台": "Rough Cut",
  "图片生成": "Image Generation",
  "视频生成": "Video Generation",
  "音乐音频": "Music & Audio",
  "角色工坊": "Character Workshop",
  "场景工坊": "Scene Workshop",
  "道具工坊": "Prop Workshop",
  "打戏工坊": "Action Workshop",
  "资源中心": "Resource Center",
  "动态分镜": "Motion Storyboard",
  "教学中心": "Tutorial Center",
  "智能改编": "Smart Adaptation",
  "传统写作": "Classic Writing",
  "剧情大纲": "Story Outline",
  "剧本中心": "Script Center",
  "故事骨架": "Story Structure",
  "小说转剧本": "Novel to Screenplay",
  "对话短剧自动流": "Dialogue Drama Auto Flow",
  "一键解说剧": "One-click Voiceover Drama",
  "费用统计": "Cost Statistics",
  "参考视频反拆": "Reference Video Reverse Engineering",
  "作品展廊": "Gallery",
  "使用指南": "Guide",
  "项目列表": "Project List",
  "项目管理": "Project Management",
  "总览": "Overview",
  "单集工作区": "Episode Workspace",
  "资产中心": "Asset Center",
  "图片资源": "Image Assets",
  "剧本快览": "Script Preview",
  "文字助手": "Text Assistant",
  "快捷入口": "Quick Access",
  "生成日志": "Generation Log",
  "更多": "More",
  "素材库管理": "Asset Library Management",
  "管理后台": "Admin Dashboard",
  "用户管理": "User Management",
  "停止下雪": "Stop Snow",
  "下雪特效": "Snow Effect",
  "点击退出登录": "Click to log out",
  "切换工作区": "Switch Workspace",
  "用户名": "Username",
  "密码": "Password",
  "新密码": "New Password",
  "确认密码": "Confirm Password",
  "登录密码": "Password",
  "请输入用户名...": "Enter username...",
  "请输入用户名": "Enter username",
  "请输入密码": "Enter password",
  "再次输入密码": "Enter password again",
  "请输入该用户的登录密码...": "Enter this user's password...",
  "隐藏密码": "Hide password",
  "显示密码": "Show password",
  "登录": "Log In",
  "设置密码": "Set Password",
  "进入工作台": "Enter Workspace",
  "设置并进入": "Set and Enter",
  "处理中...": "Processing...",
  "取消": "Cancel",
  "确认": "Confirm",
  "当前集": "Current Episode",
  "回到全部项目": "Back to All Projects",
  "回到项目总览": "Back to Project Overview",
  "国内项目": "Domestic Project",
  "出海项目": "Overseas Project",
  "默认视频供应商": "Default Video Provider",
  "AI 模型": "AI Model",
  "切换AI模型": "Switch AI Model",
  "切换主题": "Switch Theme",
  "切换画风": "Switch Visual Style",
  "画风风格": "Visual Style",
  "收起侧边栏": "Collapse Sidebar",
  "展开侧边栏": "Expand Sidebar",
  "打开菜单": "Open Menu",
  "剧本/策划": "Script & Planning",
  "故事制作": "Story Production",
  "生成工具": "Generation Tools",
  "项目工具": "Project Tools",
  "制作": "Production",
  "生成": "Generate",
  "资产": "Assets",
  "当前": "Current",
  "当前页": "Current Page",
  "当前预览": "Current Preview",
  "生成历史": "Generation History",
  "下载": "Download",
  "下载全部": "Download All",
  "下载视频": "Download Video",
  "生成视频": "Generate Video",
  "生成完成": "Generation Complete",
  "重新生成": "Regenerate",
  "重新生成分镜": "Regenerate Storyboard",
  "生成剩余分镜": "Generate Remaining Shots",
  "生成剩余视频": "Generate Remaining Videos",
  "拆分分镜": "Split Storyboard",
  "只拆提示词": "Prompt Only",
  "编辑 Prompt": "Edit Prompt",
  "复制 Prompt": "Copy Prompt",
  "去字幕": "Remove Subtitles",
  "删除": "Delete",
  "编辑": "Edit",
  "保存": "Save",
  "保存成功": "Saved",
  "保存失败": "Save failed",
  "加载中...": "Loading...",
  "加载项目信息...": "Loading project info...",
  "刷新": "Refresh",
  "上传素材": "Upload Asset",
  "上传中...": "Uploading...",
  "素材列表": "Asset List",
  "暂无素材": "No assets",
  "未命名": "Untitled",
  "未配置素材组": "Asset group not configured",
  "创建 shadonggua 素材组": "Create shadonggua asset group",
  "加载分镜中...": "Loading storyboard...",
  "正在检查登录状态...": "Checking login status...",
  "提交失败": "Submit failed",
  "未知错误": "Unknown error",
  "请求失败": "Request failed",
  "请求超时，请检查网络连接或稍后重试": "Request timed out. Check the network or retry later.",
  "返回数据解析失败": "Failed to parse returned data",
  "分镜数据解析失败": "Failed to parse storyboard data",
  "保存失败：分镜数据不是数组": "Save failed: storyboard data is not an array",
  "图片已更新！请手动下载或在对应模块重新上传使用。": "Image updated. Download it manually or upload it again in the target module.",
  "生成完成！": "Generation complete.",
  "角色": "Character",
  "场景": "Scene",
  "道具": "Prop",
  "分镜": "Shot",
  "集": "Episode",
  "已生成": "Generated",
  "生成中": "Generating",
  "失败": "Failed",
  "已完成": "Completed",
  "未开始": "Not Started",
  "处理中": "Processing",
  "已入库": "In Library",
  "素材入库": "Add to Asset Library",
  "入库中": "Adding",
  "入库失败": "Asset Import Failed",
  "无需入库": "No Import Needed",
  "加入我们": "Join Us",
  "让短剧创作进入可控生产线": "Make short drama production controllable",
  "剧本、角色、场景、道具、故事板和视频粗剪集中管理，创作资产沉淀为可复用的项目能力。": "Centrally manage scripts, characters, scenes, props, storyboards, and rough cuts so creative assets become reusable project capabilities.",
  "首次进入前需要设置登录密码。": "Set a login password before first entry.",
  "输入用户名和密码进入工作台。": "Enter your username and password to access the workspace.",
  "短剧创作者中心": "Short Drama Creator Center",
  "全局打光": "Global Lighting",
  "打光预设": "Lighting Preset",
  "导演深度分镜": "Director Deep Storyboard",
  "mx-shell风格分镜": "mx-shell Style Storyboard",
  "无选项": "None",
  "中文": "中文",
  "English": "English",
  "语言": "Language",
  "翻译": "Translate",
  "中英切换": "Chinese / English",
  "切换语言": "Switch Language",
  "开始": "Start",
  "停止": "Stop",
  "继续": "Continue",
  "暂停": "Pause",
  "重试": "Retry",
  "关闭": "Close",
  "打开": "Open",
  "提交": "Submit",
  "复制": "Copy",
  "导出": "Export",
  "导入": "Import",
  "下载全部": "Download All",
  "一键下载": "Download All",
  "一键生成": "Generate All",
  "一键入库": "Import All",
  "选择": "Select",
  "选择入口": "Select Entry",
  "确认删除": "Confirm Delete",
  "确认覆盖": "Confirm Overwrite",
  "确定": "OK",
  "跳过": "Skip",
  "完成": "Done",
  "下一步": "Next",
  "上一步": "Previous",
  "详情": "Details",
  "设置": "Settings",
  "分镜设置": "Storyboard Settings",
  "视频设置": "Video Settings",
  "生成设置": "Generation Settings",
  "基础设置": "Basic Settings",
  "高级设置": "Advanced Settings",
  "模型": "Model",
  "供应商": "Provider",
  "线路": "Route",
  "模式": "Mode",
  "类型": "Type",
  "状态": "Status",
  "时间": "Time",
  "时长": "Duration",
  "分辨率": "Resolution",
  "宽高比": "Aspect Ratio",
  "尺寸": "Size",
  "质量": "Quality",
  "风格": "Style",
  "标题": "Title",
  "描述": "Description",
  "名称": "Name",
  "别名": "Alias",
  "内容": "Content",
  "原文": "Source Text",
  "预览": "Preview",
  "当前视频": "Current Video",
  "当前音频": "Current Audio",
  "当前图片": "Current Image",
  "视频": "Video",
  "图片": "Image",
  "音频": "Audio",
  "音乐": "Music",
  "剧本": "Script",
  "小说": "Novel",
  "旁白": "Voiceover",
  "对白": "Dialogue",
  "台词": "Line",
  "提示词": "Prompt",
  "负面提示词": "Negative Prompt",
  "参考图绑定": "Reference Binding",
  "参考图": "Reference Image",
  "参考图片": "Reference Image",
  "参考视频": "Reference Video",
  "参考音频": "Reference Audio",
  "参考资产": "Reference Assets",
  "本地上传": "Local Upload",
  "从资源库选择": "Select from Library",
  "从文件追加到本集": "Append File to This Episode",
  "从文件重载本集": "Reload This Episode from File",
  "添加": "Add",
  "移除": "Remove",
  "替换": "Replace",
  "更名": "Rename",
  "扩写": "Expand",
  "变体": "Variant",
  "高级角色设计版模板": "Advanced Character Design Sheet",
  "高级角色设计板": "Advanced Character Design Board",
  "绑定音色": "Bind Voice",
  "解除绑定": "Unbind",
  "重新绑定": "Rebind",
  "查询": "Query",
  "查看": "View",
  "查看原文": "View Source",
  "查看历史记录": "View History",
  "查看当前片段的视频生成历史": "View video generation history for this segment",
  "查看角色工坊": "View Character Workshop",
  "查看场景工坊": "View Scene Workshop",
  "查看道具工坊": "View Prop Workshop",
  "按模型": "By Model",
  "按用户": "By User",
  "按项目": "By Project",
  "按模型拆分": "Breakdown by Model",
  "操作": "Actions",
  "操作日志": "Operation Log",
  "操作失败": "Operation Failed",
  "测试项": "Test Item",
  "传参 JSON": "Request JSON",
  "返回内容": "Response",
  "成功": "Success",
  "警告": "Warning",
  "错误": "Error",
  "异常": "Exception",
  "排队中": "Queued",
  "等待中": "Waiting",
  "已停止": "Stopped",
  "已取消": "Canceled",
  "已跳过": "Skipped",
  "已复制": "Copied",
  "已删除": "Deleted",
  "已更新": "Updated",
  "已保存": "Saved",
  "已提交": "Submitted",
  "已创建": "Created",
  "已选择": "Selected",
  "未选择": "Not Selected",
  "无数据": "No Data",
  "暂无数据": "No Data",
  "暂无结果": "No Results",
  "暂无视频": "No Video",
  "暂无图片": "No Image",
  "暂无音频": "No Audio",
  "暂无历史": "No History",
  "空": "Empty",
  "全部": "All",
  "默认": "Default",
  "国内": "Domestic",
  "海外": "Overseas",
  "中国现代真人短剧": "Chinese Modern Live-action Short Drama",
  "中国古代真人短剧": "Chinese Historical Live-action Short Drama",
  "中国古代玄幻真人短剧": "Chinese Fantasy Historical Live-action Short Drama",
  "真人电影": "Live-action Cinema",
  "电影CG动画": "Cinematic CG Animation",
  "半写实3D乙女CG": "Semi-realistic 3D Otome CG",
  "中国3D国漫": "Chinese 3D Donghua",
  "皮克斯3D动画": "Pixar-style 3D Animation",
  "中国国漫2D": "Chinese 2D Donghua",
  "日漫2D": "Japanese 2D Anime",
  "2D赛璐璐动画": "2D Cel Animation",
  "导入剧本": "Import Script",
  "导入与改写": "Import & Rewrite",
  "资产确认": "Asset Review",
  "自动生成": "Auto Generation",
  "完成与交付": "Completion & Delivery",
  "开始生成资产": "Start Asset Generation",
  "确认资产并继续": "Confirm Assets and Continue",
  "自动流": "Auto Flow",
  "全自动": "Fully Automatic",
  "演示模式": "Demo Mode",
  "新建草稿": "New Draft",
  "开始生成": "Start Generation",
  "生成音乐": "Generate Music",
  "生成纯音乐": "Generate Instrumental Music",
  "分析剧本": "Analyze Script",
  "拆分音乐段落": "Split Music Segments",
  "音乐描述": "Music Description",
  "歌词": "Lyrics",
  "纯音乐可留空": "Leave empty for instrumental music",
  "纯音乐": "Instrumental",
  "生成参数": "Generation Parameters",
  "生成历史": "Generation History",
  "播放": "Play",
  "停止播放": "Stop Playback",
  "重新播放": "Replay",
  "打戏": "Action",
  "特效": "VFX",
  "法术": "Spell",
  "动作": "Motion",
  "动作分镜": "Action Storyboard",
  "特效工坊": "VFX Workshop",
  "生成参考图": "Generate Reference Image",
  "生成参考视频": "Generate Reference Video",
  "超分": "Upscale",
  "超分中": "Upscaling",
  "超分完成": "Upscale Complete",
  "超分失败": "Upscale Failed",
  "超分任务已提交": "Upscale task submitted",
  "资源库": "Resource Library",
  "资源库选择": "Resource Library Selection",
  "国内项目素材库": "Domestic Project Asset Library",
  "出海项目素材库": "Overseas Project Asset Library",
  "素材组": "Asset Group",
  "素材资产": "Material Asset",
  "素材名称": "Asset Name",
  "素材类型": "Asset Type",
  "素材状态": "Asset Status",
  "创建素材组": "Create Asset Group",
  "创建素材资产": "Create Material Asset",
  "查询素材资产": "Query Material Asset",
  "真人素材组": "Live-action Asset Group",
  "真人素材": "Live-action Asset",
  "入库状态": "Import Status",
  "停止入库": "Stop Import",
  "重新入库": "Re-import",
  "批量入库": "Batch Import",
  "分镜组": "Segment",
  "镜头": "Shot",
  "片段": "Segment",
  "粗剪连播": "Rough Cut Playback",
  "从当前指针播放": "Play from Current Marker",
  "视频片段": "Video Segment",
  "生成分镜视频": "Generate Storyboard Videos",
  "拆分剧情大纲": "Split Story Outline",
  "拆剧本": "Split Script",
  "按集拆分": "Split by Episode",
  "拆分完成": "Split Complete",
  "拆分失败": "Split Failed",
  "拆分中...": "Splitting...",
  "场景拆分": "Scene Breakdown",
  "角色拆分": "Character Breakdown",
  "道具拆分": "Prop Breakdown",
  "五要素": "Five Elements",
  "情节点": "Plot Points",
  "可拍性分析": "Shootability Analysis",
  "角色画像": "Character Profile",
  "角色名称": "Character Name",
  "场景名称": "Scene Name",
  "道具名称": "Prop Name",
  "角色描述": "Character Description",
  "场景描述": "Scene Description",
  "道具描述": "Prop Description",
  "创建新项目": "Create New Project",
  "项目名称": "Project Name",
  "项目类型": "Project Type",
  "项目状态": "Project Status",
  "项目默认使用": "Project default",
  "当前状态": "Current Status",
  "初始化进度": "Initialization Progress",
  "新项目初始化": "New Project Setup",
  "从哪里开始这个项目？": "Where should this project start?",
  "先把项目地基搭好。导入剧本会自动拆分分集，并继续生成剧情大纲、角色、场景和道具。": "Build the project foundation first. Importing a script will automatically split episodes and continue generating the outline, characters, scenes, and props.",
  "稍后再说": "Do It Later",
  "已有完整剧本": "Complete Script Exists",
  "从灵感开始": "Start from an Idea",
  "小说原文自动流": "Novel Source Auto Flow",
  "进入项目": "Enter Project",
  "载入小说": "Load Novel",
  "补齐已有集数": "Complete Existing Episodes",
  "确认素材": "Review Assets",
  "分集生产": "Episode Production",
  "分集生成": "Episode Generation",
  "一键下载每集 zip": "Download Each Episode ZIP",
  "音乐音频生成": "Music & Audio Generation",
  "项目级 BGM、片尾曲、情绪音乐": "Project-level BGM, ending songs, and emotional music",
  "剧本配乐": "Script Scoring",
  "粘贴当前集剧本、剧情大纲或完整片段...": "Paste the current episode script, story outline, or complete segment...",
  "配乐要求": "Music Requirements",
  "规划总时长": "Planned Total Duration",
  "音乐模型": "Music Model",
  "音乐段落": "Music Segments",
  "音乐提示词": "Music Prompt",
  "随机风格": "Random Style",
  "可选": "Optional",
  "用途": "Use Case",
  "人声": "Vocals",
  "速度": "Tempo",
  "慢速": "Slow",
  "中速": "Medium",
  "中快速": "Medium Fast",
  "快速": "Fast",
  "结构走向": "Structure Direction",
  "风格预设": "Style Presets",
  "标签建议": "Tag Suggestions",
  "情绪与乐器": "Mood & Instruments",
  "添加自定义标签": "Add custom tag",
  "搜索音乐": "Search music",
  "正在查看": "Viewing",
  "音频播放进度": "Audio Playback Progress",
  "音量": "Volume",
  "实拍短剧": "Live-action Short Drama",
  "解说剧": "Voiceover Drama",
  "无增强": "No Enhancement",
  "使用原有拆分逻辑，不额外加入增强约束。": "Use the original split logic without extra enhancement constraints.",
  "强化站位、轴线、切点、反应镜头和节奏。": "Strengthen blocking, axis, cut points, reaction shots, and pacing.",
  "强化画面构造、可拍动作、视觉落点和电影化描述。": "Strengthen visual construction, shootable action, focal points, and cinematic description.",
  "动作打斗": "Action Fight",
  "强化起势、接触、冲击、余波和身体力学。": "Strengthen wind-up, contact, impact, aftermath, and body mechanics.",
  "特效镜头": "VFX Shot",
  "强化特效来源、路径、尺度、环境互动和消散。": "Strengthen VFX source, path, scale, environmental interaction, and dissipation.",
  "情绪微反应": "Emotional Micro-reaction",
  "强化人物小动作、下意识反应和情绪落点。": "Strengthen small actions, subconscious reactions, and emotional landing points.",
  "物理真实感": "Physical Realism",
  "强化动作起点、路径、接触点、终点和连续性。": "Strengthen action start, path, contact point, endpoint, and continuity.",
  "构图画面": "Visual Composition",
  "强化前中后景、视觉锚点、光线和画面层次。": "Strengthen foreground/midground/background, visual anchors, lighting, and depth.",
  "提示词优化": "Prompt Optimization",
  "强化输出前自检，减少抽象句、乱用资产和格式漂移。": "Strengthen pre-output self-checks and reduce abstract wording, asset misuse, and format drift.",
  "未知时间": "Unknown Time",
  "待生成": "Pending Generation",
  "待拆分": "Pending Split",
  "未知": "Unknown",
  "未知模型": "Unknown Model",
  "当前场景": "Current Scene",
  "日": "Day",
  "夜": "Night",
  "无": "None",
  "正面视角": "Front View",
  "反面视角": "Reverse View",
  "背面视角": "Back View",
  "侧面视角": "Side View",
  "正面": "Front",
  "反面": "Reverse",
  "背面": "Back",
  "侧面": "Side",
  "全身": "Full Body",
  "半身": "Half Body",
  "近景": "Close Shot",
  "远景": "Long Shot",
  "中景": "Medium Shot",
  "特写": "Close-up",
  "当前集缺少正式剧本": "Current episode has no finalized script",
  "正在加载小故事板": "Loading Mini Storyboard",
  "正在读取剧本、分镜组、视频状态和资产参考图。": "Reading script, segments, video status, and asset references.",
  "分镜增强模式": "Storyboard Enhancement Modes",
  "可多选组合，建议一次 1-3 项。": "Multiple choices supported. 1-3 items are recommended.",
  "关闭原文抽屉": "Close Source Drawer",
  "暂无原文内容": "No source content",
  "关闭生成历史": "Close Generation History",
  "当前片段": "Current Segment",
  "当前片段还没有可用生成历史": "No usable generation history for this segment",
  "收起参考图绑定": "Collapse Reference Binding",
  "展开参考图绑定": "Expand Reference Binding",
  "加载生成历史失败": "Failed to load generation history",
  "加载小故事板失败": "Failed to load mini storyboard",
  "当前集没有剧本内容，先保存剧本再生成小故事板": "This episode has no script. Save the script before generating the mini storyboard.",
  "正在提交任务": "Submitting task",
  "任务执行中": "Task running",
  "正在写入全局打光": "Writing global lighting",
  "重新拆分分镜": "Resplit Storyboard",
  "重新拆分": "Resplit",
  "这个资产没有可用图片，无法绑定为参考图": "This asset has no usable image and cannot be bound as a reference.",
  "替换参考图失败": "Failed to replace reference image",
  "移除参考图失败": "Failed to remove reference image",
  "已切换到这条历史视频": "Switched to this historical video",
  "切换历史视频失败": "Failed to switch historical video",
  "当前没有可写入打光的分镜，先拆分分镜再设置全局打光": "No storyboard segment can receive lighting yet. Split the storyboard before setting global lighting.",
  "全局打光保存失败": "Failed to save global lighting",
  "插入分镜组失败": "Failed to insert segment",
  "删除分镜组失败": "Failed to delete segment",
  "小故事板参考图": "Mini Storyboard Reference Image",
  "当前分镜组没有视频提示词": "The current segment has no video prompt",
  "当前分镜组没有匹配到参考图，将按纯文本视频生成": "No matching reference image was found for the current segment. It will generate as text-only video.",
  "参考图还没有完成 GuaVideo 素材入库，未提交视频。请稍后重试。": "Reference images have not finished GuaVideo asset import, so the video was not submitted. Retry later.",
  "提交当前视频失败": "Failed to submit current video",
  "重复提交当前视频": "Submit current video again",
  "重新生成当前视频": "Regenerate current video",
  "当前分镜组的视频还在生成中。继续会再次提交一个新的视频任务，可能产生重复费用。确定继续？": "The current segment video is still generating. Continuing will submit another video task and may create duplicate costs. Continue?",
  "当前分镜组已经有视频。继续会重新提交生成任务，完成后会替换当前预览并写入生成历史。确定继续？": "The current segment already has a video. Continuing will submit a new generation task, replace the current preview after completion, and write it into generation history. Continue?",
  "继续提交": "Submit Again",
  "继续生成": "Continue Generation",
  "没有需要生成的视频": "No videos need generation",
  "生成分镜视频失败": "Failed to generate storyboard videos",
  "先拆分小故事板，再生成当前集音乐": "Split the mini storyboard before generating music for this episode.",
  "正在规划音乐段落": "Planning music segments",
  "为当前集生成能覆盖完整粗剪时间线的纯音乐，按情绪转折切换，不要人声、歌词、口播或旁白。": "Generate instrumental music that covers the full rough-cut timeline for this episode, switching with emotional turns. No vocals, lyrics, spoken narration, or voiceover.",
  "短剧BGM，纯音乐，情绪递进": "Short drama BGM, instrumental, emotional progression",
  "音乐生成失败": "Music generation failed",
  "当前集纯音乐已生成": "Instrumental music for this episode has been generated",
  "生成当前集音乐失败": "Failed to generate music for this episode",
  "已保存当前分镜组": "Current segment saved",
  "保存失败，请检查 JSON 格式": "Save failed. Check the JSON format.",
  "当前分镜组没有提示词，先拆分分镜再选择打光": "The current segment has no prompt. Split the storyboard before choosing lighting.",
  "已加入打光提示词，保存后生效": "Lighting prompt added. Save to apply it.",
  "已加入打光提示词": "Lighting prompt added",
  "写入打光提示词失败": "Failed to write lighting prompt",
  "视频提示词已复制": "Video prompt copied",
  "复制失败，请手动选择文本复制": "Copy failed. Select the text manually to copy.",
  "当前分镜组还没有可下载的视频": "Current segment has no downloadable video",
  "还没有已完成的视频可下载": "No completed videos are available to download",
  "超分完成但没有返回视频地址": "Upscale completed but returned no video URL",
  "视频超分失败": "Video upscale failed",
  "视频超分状态查询失败": "Failed to query video upscale status",
  "当前分镜组还没有可超分的视频": "Current segment has no video available for upscale",
  "当前分镜组正在超分": "Current segment is being upscaled",
  "后端未返回超分任务ID": "Backend returned no upscale task ID",
  "提交视频超分失败": "Failed to submit video upscale",
  "当前分镜组还没有可去字幕的视频": "Current segment has no video available for subtitle removal",
  "缺少方舟原始视频链接，重新生成当前视频后再去字幕": "Missing original Ark video URL. Regenerate the current video before removing subtitles.",
  "当前分镜组正在去字幕": "Current segment is removing subtitles",
  "后端未返回去字幕任务ID": "Backend returned no subtitle-removal task ID",
  "去字幕完成但没有返回视频地址": "Subtitle removal completed but returned no video URL",
  "去字幕结果保存失败": "Failed to save subtitle-removal result",
  "去字幕失败": "Subtitle removal failed",
  "提交去字幕失败": "Failed to submit subtitle removal",
  "视频模型": "Video Model",
  "清晰度": "Resolution",
  "视频比例": "Video Aspect Ratio",
  "辅助": "Assist",
  "根据当前集小故事板情绪生成纯音乐 BGM": "Generate instrumental BGM from the current episode mini storyboard mood",
  "下载全部已完成视频为压缩包": "Download all completed videos as a ZIP",
  "暂无已完成视频": "No completed videos",
  "对当前预览视频发起腾讯云超分，完成后替换当前预览并写入生成历史": "Run Tencent Cloud upscale on the current preview video. On completion, replace the preview and write it into generation history.",
  "分镜": "Storyboard",
  "删除当前分镜组": "Delete current segment",
  "重试视频": "Retry Video",
  "重新生成视频": "Regenerate Video",
  "生成当前视频": "Generate Current Video",
  "下载当前分镜组视频": "Download current segment video",
  "当前分镜组还没有生成视频": "Current segment has no generated video",
  "去字幕（仅限 GuaVideo 方舟原始链接有效期内视频）": "Remove subtitles (only valid for GuaVideo Ark original links within their validity period)",
  "阿里生图/修图": "Alibaba image generation/editing",
  "字节/即梦技术栈": "ByteDance / Jimeng stack",
  "最新Nano banana2": "Latest Nano Banana 2",
  "DeepSeek推理分镜，Vidu生成图片": "DeepSeek reasoning storyboard, Vidu image generation",
  "使用示例数据快速体验流程": "Use sample data to quickly try the workflow",
  "(不支持)": "(Unsupported)",
  "(错峰)": "(Staggered)",
  "(角色一致性)": "(Character Consistency)",
  "(首帧)": "(First Frame)",
  "（推荐）": "(Recommended)",
  "（无返回内容）": "(No response content)",
  "（无描述）": "(No description)",
  "（暂无卡片）": "(No cards)",
  "1:1 方形": "1:1 Square",
  "16:9 宽屏": "16:9 Widescreen",
  "9:16 竖屏": "9:16 Vertical",
  "4:3 标准": "4:3 Standard",
  "4:3 电视": "4:3 TV",
  "2.35:1 电影": "2.35:1 Cinema",
  "21:9 超宽": "21:9 Ultrawide",
  "21:9 超宽屏": "21:9 Ultrawide",
  "3:4 竖版": "3:4 Vertical",
  "3:4 竖向": "3:4 Vertical",
  "3:2 横向": "3:2 Landscape",
  "1080P (推荐)": "1080P (Recommended)",
  "2.0 标准": "2.0 Standard",
  "12格导演板": "12-panel Director Board",
  "3x3过程板": "3x3 Process Board",
  "9宫格剧情法": "9-grid Story Method",
  "9个关键节点": "9 Key Nodes",
  "未登录": "Not Logged In",
  "未选择集数": "No Episode Selected",
  "该账号还未设置密码，请退出后在登录页设置密码": "This account has no password yet. Log out and set a password on the login page.",
  "登录失败": "Login failed",
  "已切换到": "Switched to",
  "主题": "Theme",
  "画风": "Visual Style",
  "AI正在分析剧本并提取角色/场景/道具，请稍候...": "AI is analyzing the script and extracting characters, scenes, and props. Please wait...",
  "AI正在分析剧本并生成角色/场景/道具图片，请耐心等待...": "AI is analyzing the script and generating character, scene, and prop images. Please wait...",
  "解说漫剧本解析中，提取资产并生成分镜...": "Parsing the voiceover drama script, extracting assets, and generating storyboards...",
  "AI正在生成9宫格提示词节点，请稍候...": "AI is generating 9-grid prompt nodes. Please wait...",
  "AI正在生成视频分镜提示词，请稍候...": "AI is generating video storyboard prompts. Please wait...",
  "解说漫剧本解析中，跳过编剧直接进入分镜师...": "Parsing the voiceover drama script, skipping writing and entering storyboard generation...",
  "分镜生成已提交，请稍候...": "Storyboard generation submitted. Please wait...",
  "9宫格数据缺少 nine_grid_prompt 字段": "9-grid data is missing the nine_grid_prompt field",
  "9宫格数据缺少 four_grid_prompts 字段": "9-grid data is missing the four_grid_prompts field",
  "分镜数据解析失败，请检查 AI 返回格式": "Storyboard data parsing failed. Check the AI response format.",
  "数据不是数组": "Data is not an array",
  "本集暂无分镜": "No storyboard for this episode",
  "暂无已有资产": "No existing assets",
  "跳过此资产": "Skip this asset",
  "已有资产：": "Existing asset:",
  "新建并生图": "Create and generate image",
  "指定为已有": "Set as existing",
  "选择变体：": "Select variant:",
  "请输入台词": "Enter line text",
  "请选择音色": "Select voice",
  "请求异常": "Request error",
  "台词文本": "Line Text",
  "请输入要合成的台词...": "Enter the line to synthesize...",
  "选择音色": "Select Voice",
  "语速": "Speech Rate",
  "正在合成语音...": "Synthesizing voice...",
  "开始生成语音": "Start Voice Generation",
  "未命名角色": "Unnamed Character",
  "请填写角色名称": "Enter character name",
  "请填写角色别名": "Enter character alias",
  "请填写角色描述": "Enter character description",
  "最多5张参考图": "Up to 5 reference images",
  "更新失败": "Update failed",
  "角色已创建！": "Character created!",
  "角色定妆照": "Character Reference Sheet",
  "所有角色都已有图片，无需生成": "All characters already have images. No generation needed.",
  "该角色没有描述，无法重新生成": "This character has no description and cannot be regenerated.",
  "请填写修改描述": "Enter edit description",
  "微调完成！": "Fine-tuning complete!",
  "微调失败": "Fine-tuning failed",
  "图片已替换": "Image replaced",
  "3D 视角": "3D View",
  "全景": "Panorama",
  "变体已删除": "Variant deleted",
  "该变体没有描述，无法重新生成": "This variant has no description and cannot be regenerated.",
  "变体已重新生成！": "Variant regenerated!",
  "变体微调完成！": "Variant fine-tuning complete!",
  "变体图片已替换": "Variant image replaced",
  "没有变体图，无法入库": "No variant image is available for import",
  "变体描述已更新": "Variant description updated",
  "请先写一点性格或粗略描述": "Enter some personality or rough description first",
  "已扩写成人物生成提示词": "Expanded into a character generation prompt",
  "扩写失败": "Expansion failed",
  "已按五官体态规则扩写": "Expanded using facial/body-shape rules",
  "角色主体图先入库成功后再绑定音色": "Import the main character image successfully before binding a voice",
  "音频不能超过15MB": "Audio cannot exceed 15 MB",
  "音色已绑定": "Voice bound",
  "音色已解除": "Voice unbound",
  "解除音色失败": "Failed to unbind voice",
  "没有主体图，无法上传素材库": "No main image is available for asset-library upload",
  "角色主体": "Character Main Image",
  "主体图入库失败": "Main image import failed",
  "没有可入库的角色图片": "No character images are available for import",
  "已停止批量入库提交，可以重新入库": "Batch import submission stopped. You can import again.",
  "已停止入库状态，可以重新入库": "Import status stopped. You can import again.",
  "请填写变体名称": "Enter variant name",
  "请填写换装描述": "Enter outfit-change description",
  "请上传参考图": "Upload a reference image",
  "换装，参考服装图片": "Outfit change, reference clothing image",
  "角色图片入库完成": "Character image import complete",
  "张": "images",
  "系统提示词": "System Prompt",
  "完整请求参数": "Full Request Parameters",
  "请求 JSON": "Request JSON",
  "返回 JSON": "Response JSON",
  "复制 JSON": "Copy JSON",
  "导出 JSON": "Export JSON",
  "复制提示词": "Copy Prompt",
  "复制视频提示词": "Copy Video Prompt",
  "项目 ID": "Project ID",
  "集 ID": "Episode ID",
  "音色 ID": "Voice ID",
  "素材组": "Asset Group",
  "智能体任务": "Agent Task",
};

export const UI_TRANSLATIONS_REVERSE = Object.fromEntries(
  Object.entries(UI_TRANSLATIONS).map(([zh, en]) => [en, zh])
);

const UI_TRANSLATION_PATTERNS = [
  [/^第\s*(\d+)\s*集$/, "Episode $1"],
  [/^第\s*(\d+)\s*章$/, "Chapter $1"],
  [/^第\s*(\d+)\s*页$/, "Page $1"],
  [/^分镜组\s*(\d+)$/, "Segment $1"],
  [/^分镜\s*(\d+)$/, "Shot $1"],
  [/^镜头\s*(\d+)$/, "Shot $1"],
  [/^片段\s*(\d+)$/, "Segment $1"],
  [/^图片\s*(\d+)$/, "Image $1"],
  [/^视频\s*(\d+)$/, "Video $1"],
  [/^音频\s*(\d+)$/, "Audio $1"],
  [/^角色\s*(\d+)$/, "Character $1"],
  [/^场景\s*(\d+)$/, "Scene $1"],
  [/^道具\s*(\d+)$/, "Prop $1"],
  [/^参考图\s*(\d+)$/, "Reference Image $1"],
  [/^(\d+)\s*秒$/, "$1 sec"],
  [/^(\d+)\s*分钟$/, "$1 min"],
  [/^(\d+)\s*小时$/, "$1 hr"],
  [/^(\d+)\s*天前$/, "$1 days ago"],
  [/^(\d+)\s*小时前$/, "$1 hours ago"],
  [/^(\d+)\s*分钟前$/, "$1 minutes ago"],
  [/^(\d+)\s*张$/, "$1 images"],
  [/^(\d+)\s*条$/, "$1 items"],
  [/^(\d+)\s*次$/, "$1 times"],
  [/^(\d+)\s*字$/, "$1 chars"],
  [/^(\d+)\s*字符$/, "$1 chars"],
  [/^(\d+)\s*集$/, "$1 episodes"],
  [/^(\d+)\s*段$/, "$1 segments"],
  [/^(\d+)\s*个片段$/, "$1 segments"],
  [/^(\d+)\s*个素材$/, "$1 assets"],
  [/^一键生成完成[:：]\s*(\d+)\s*\/\s*(\d+)\s*个(.+)$/, "One-click generation complete: $1/$2 $3"],
  [/^(\d+)\s*\/\s*(\d+)\s*个(.+)$/, "$1/$2 $3"],
  [/^一键生成完成[:：]\s*(.*)$/, "One-click generation complete: $1"],
  [/^(\d+)\s*\/\s*(\d+)\s*段$/, "$1 / $2 segments"],
  [/^共\s*(\d+)\s*个$/, "$1 total"],
  [/^共\s*(\d+)\s*个\s*\/\s*(\d+)\s*页$/, "$1 total / $2 pages"],
  [/^共\s*(\d+)\s*个，?(\d+)\s*\/\s*(\d+)\s*页$/, "$1 total, page $2 / $3"],
  [/^已生成\s*(\d+)\s*集$/, "$1 episodes generated"],
  [/^已生成\s*(\d+)\s*个$/, "$1 generated"],
  [/^生成中\s*(\d+)\s*个$/, "$1 generating"],
  [/^成功下载\s*(\d+)\s*个视频$/, "Downloaded $1 videos"],
  [/^角色图片入库完成\s*(\d+)\s*张[，,]\s*失败\s*(\d+)\s*张$/, "Character image import complete: $1 succeeded, $2 failed"],
  [/^已提交\s*(\d+)\s*张角色图片入库$/, "Submitted $1 character images for import"],
  [/^生成失败[:：]?\s*(.*)$/, "Generation failed: $1"],
  [/^加载失败[:：]?\s*(.*)$/, "Load failed: $1"],
  [/^保存失败[:：]?\s*(.*)$/, "Save failed: $1"],
  [/^上传失败[:：]?\s*(.*)$/, "Upload failed: $1"],
  [/^提交失败[:：]?\s*(.*)$/, "Submit failed: $1"],
  [/^创建失败[:：]?\s*(.*)$/, "Create failed: $1"],
  [/^删除失败[:：]?\s*(.*)$/, "Delete failed: $1"],
  [/^查询失败[:：]?\s*(.*)$/, "Query failed: $1"],
  [/^处理失败[:：]?\s*(.*)$/, "Processing failed: $1"],
  [/^绑定音色失败[:：]?\s*(.*)$/, "Voice binding failed: $1"],
  [/^参数 JSON 解析失败[:：]?\s*(.*)$/, "Request JSON parse failed: $1"],
  [/^(.+?)已复制$/, "$1 copied"],
  [/^(.+?)已更新$/, "$1 updated"],
  [/^(.+?)已更名$/, "$1 renamed"],
  [/^(.+?)失败[:：]?\s*(.*)$/, "$1 failed: $2"],
  [/^正在(.+?)\.\.\.$/, "$1 in progress..."],
  [/^(.+?)中\.\.\.$/, "$1..."],
];

const UI_RESTORE_PATTERNS = [
  [/^Episode\s+(\d+)$/, "第$1集"],
  [/^Chapter\s+(\d+)$/, "第$1章"],
  [/^Page\s+(\d+)$/, "第$1页"],
  [/^Segment\s+(\d+)$/, "分镜组 $1"],
  [/^Shot\s+(\d+)$/, "镜头 $1"],
  [/^Image\s+(\d+)$/, "图片$1"],
  [/^Video\s+(\d+)$/, "视频$1"],
  [/^Audio\s+(\d+)$/, "音频$1"],
  [/^Character\s+(\d+)$/, "角色$1"],
  [/^Scene\s+(\d+)$/, "场景$1"],
  [/^Prop\s+(\d+)$/, "道具$1"],
  [/^Reference Image\s+(\d+)$/, "参考图$1"],
  [/^(\d+)\s+sec$/, "$1 秒"],
  [/^(\d+)\s+min$/, "$1 分钟"],
  [/^(\d+)\s+hr$/, "$1 小时"],
  [/^(\d+)\s+images$/, "$1 张"],
  [/^(\d+)\s+items$/, "$1 条"],
  [/^(\d+)\s+times$/, "$1 次"],
  [/^(\d+)\s+chars$/, "$1 字符"],
  [/^(\d+)\s+episodes$/, "$1 集"],
  [/^(\d+)\s+segments$/, "$1 段"],
  [/^(.+?) failed[:：]\s*(.*)$/, "$1失败：$2"],
  [/^Generation failed[:：]\s*(.*)$/, "生成失败：$1"],
  [/^Load failed[:：]\s*(.*)$/, "加载失败：$1"],
  [/^Save failed[:：]\s*(.*)$/, "保存失败：$1"],
  [/^Upload failed[:：]\s*(.*)$/, "上传失败：$1"],
  [/^Submit failed[:：]\s*(.*)$/, "提交失败：$1"],
  [/^Create failed[:：]\s*(.*)$/, "创建失败：$1"],
  [/^Delete failed[:：]\s*(.*)$/, "删除失败：$1"],
  [/^Query failed[:：]\s*(.*)$/, "查询失败：$1"],
  [/^Processing failed[:：]\s*(.*)$/, "处理失败：$1"],
  [/^SYSTEM PROMPT$/, "系统提示词"],
  [/^EMPTY$/, "空"],
  [/^Role:\s*Director\.\.\.$/, "角色：导演..."],
];

const UI_FRAGMENT_TRANSLATIONS = {
  "故事板导演台": "Storyboard Director",
  "小故事板": "Mini Storyboard",
  "分镜编辑器": "Shot Editor",
  "剧本中心": "Script Center",
  "角色工坊": "Character Workshop",
  "场景工坊": "Scene Workshop",
  "道具工坊": "Prop Workshop",
  "打戏工坊": "Action Workshop",
  "特效工坊": "VFX Workshop",
  "音乐音频": "Music & Audio",
  "资源中心": "Resource Center",
  "资产中心": "Asset Center",
  "管理后台": "Admin Dashboard",
  "剧情大纲": "Story Outline",
  "生成历史": "Generation History",
  "参考图绑定": "Reference Binding",
  "参考图": "Reference Image",
  "参考视频": "Reference Video",
  "参考音频": "Reference Audio",
  "参考资产": "Reference Assets",
  "生成视频": "Generate Video",
  "重新生成": "Regenerate",
  "拆分分镜": "Split Storyboard",
  "生成剩余视频": "Generate Remaining Videos",
  "分镜设置": "Storyboard Settings",
  "视频设置": "Video Settings",
  "全局打光": "Global Lighting",
  "导演深度分镜": "Director Deep Storyboard",
  "提示词": "Prompt",
  "分镜": "Storyboard",
  "生图": "Image Generation",
  "生成": "Generate",
  "加载": "Load",
  "负面": "Negative",
  "完整请求参数": "Full Request Parameters",
  "请求参数": "Request Parameters",
  "返回内容": "Response Content",
  "传参": "Request Payload",
  "最终提交": "Final Submit",
  "分镜组": "Segment",
  "镜头": "Shot",
  "片段": "Segment",
  "角色": "Character",
  "场景": "Scene",
  "道具": "Prop",
  "素材库": "Asset Library",
  "素材": "Asset",
  "资产": "Asset",
  "资源库": "Resource Library",
  "资源": "Resource",
  "入库": "Import",
  "上传": "Upload",
  "下载": "Download",
  "复制": "Copy",
  "删除": "Delete",
  "编辑": "Edit",
  "保存": "Save",
  "确认": "Confirm",
  "取消": "Cancel",
  "查询": "Query",
  "创建": "Create",
  "刷新": "Refresh",
  "提交": "Submit",
  "导入": "Import",
  "导出": "Export",
  "替换": "Replace",
  "移除": "Remove",
  "切换": "Switch",
  "插入": "Insert",
  "追加": "Append",
  "重载": "Reload",
  "覆盖": "Overwrite",
  "归档": "Archive",
  "已保存到": "Saved to ",
  "播放": "Play",
  "停止": "Stop",
  "继续": "Continue",
  "重试": "Retry",
  "关闭": "Close",
  "打开": "Open",
  "失败": "Failed",
  "成功": "Success",
  "完成": "Complete",
  "生成中": "Generating",
  "处理中": "Processing",
  "排队中": "Queued",
  "未开始": "Not Started",
  "已生成": "Generated",
  "已完成": "Completed",
  "已入库": "In Library",
  "暂无": "No ",
  "没有": "No ",
  "缺少": "Missing",
  "可用": "Usable",
  "历史": "History",
  "原文": "Source",
  "抽屉": "Drawer",
  "当前": "Current",
  "全部": "All",
  "国内": "Domestic",
  "海外": "Overseas",
  "项目": "Project",
  "默认": "Default",
  "剧本": "Script",
  "小说": "Novel",
  "音乐": "Music",
  "音频": "Audio",
  "图片": "Image",
  "视频": "Video",
  "模型": "Model",
  "风格": "Style",
  "语言": "Language",
  "状态": "Status",
  "时间": "Time",
  "时长": "Duration",
  "分辨率": "Resolution",
  "清晰度": "Resolution",
  "比例": "Aspect Ratio",
  "宽高比": "Aspect Ratio",
  "线路": "Route",
  "节点": "Node",
  "连接": "Connection",
  "连线": "Edge",
  "画布": "Canvas",
  "卡片": "Card",
  "数据": "Data",
  "数组": "Array",
  "草稿": "Draft",
  "后端": "Backend",
  "工作流": "Workflow",
  "轮询": "Polling",
  "批量": "Batch",
  "按钮": "Button",
  "点击": "Click",
  "工具栏": "Toolbar",
  "全选": "Select All",
  "选中": "Selected",
  "高亮": "Highlighted",
  "显示": "Display",
  "视图": "View",
  "详情": "Details",
  "结构": "Structure",
  "顺序": "Order",
  "逻辑关系": "Logic Relationship",
  "缩放": "Zoom",
  "拖拽": "Drag",
  "增强": "Enhancement",
  "参数": "Parameters",
  "标签": "Tag",
  "建议": "Suggestion",
  "用途": "Use Case",
  "人声": "Vocals",
  "速度": "Tempo",
  "音效": "Sound Effect",
  "运动幅度": "Motion Range",
  "支持": "Supports",
  "不支持": "Unsupported",
  "推荐": "Recommended",
  "错峰": "Staggered",
  "一致性": "Consistency",
  "首帧": "First Frame",
  "返回": "Return",
  "描述": "Description",
  "名称": "Name",
  "别名": "Alias",
  "可选": "Optional",
  "通常是": "Usually",
  "CORS 跨域问题": "CORS issue",
  "通常": "Usually",
  "跨域问题": "CORS issue",
  "9宫格": "9-grid",
  "宫格": "Grid",
  "横向": "Landscape",
  "竖向": "Vertical",
  "竖版": "Vertical",
  "宽屏": "Widescreen",
  "方形": "Square",
  "标准": "Standard",
  "电视": "TV",
  "电影": "Cinema",
  "超宽": "Ultrawide",
  "短剧": "Short Drama",
  "纯音乐": "Instrumental",
  "配乐": "Score",
  "段落": "Segment",
  "规划": "Plan",
  "总": "Total",
  "慢速": "Slow",
  "中速": "Medium",
  "快速": "Fast",
  "请稍候": "Please wait",
  "请耐心等待": "Please wait",
  "请输入": "Enter",
  "请选择": "Select",
  "请填写": "Enter",
  "填写": "Fill in",
  "选择": "Select",
  "已有": "Existing",
  "新建": "Create New",
  "指定为": "Set as",
  "跳过": "Skip",
  "无法": "Cannot",
  "无需": "No need to",
  "所有": "All",
  "本集": "This Episode",
  "解析": "Parse",
  "提取": "Extract",
  "字段": "Field",
  "格式": "Format",
  "检查": "Check",
  "返回格式": "Response Format",
  "账号": "Account",
  "密码": "Password",
  "退出": "Log out",
  "登录页": "Login Page",
  "设置密码": "Set Password",
  "登录": "Log In",
  "更新": "Update",
  "请求": "Request",
  "异常": "Error",
  "语音": "Voice",
  "语速": "Speech Rate",
  "合成": "Synthesize",
  "台词": "Line",
  "音色": "Voice",
  "绑定": "Bind",
  "解除": "Unbind",
  "修改": "Edit",
  "微调": "Fine-tune",
  "扩写": "Expand",
  "定妆照": "Reference Sheet",
  "已替换": "Replaced",
  "已创建": "Created",
  "已切换到": "Switched to ",
  "一键生成完成": "One-click generation complete",
  "一键": "One-click",
  "正在分析": "Analyzing",
  "正在生成": "Generating",
  "正在合成": "Synthesizing",
  "提交失败": "Submit Failed",
  "解析失败": "Parse Failed",
  "变体": "Variant",
  "主体图": "Main Image",
  "主体": "Main",
  "人物": "Character",
  "五官体态": "Facial/Body Shape",
  "规则": "Rules",
  "服装": "Clothing",
  "换装": "Outfit Change",
  "性格": "Personality",
  "粗略": "Rough",
  "一点": "Some",
  "先": "First",
  "可以": "Can",
  "重新": "Re",
};

const UI_FRAGMENT_RESTORE_TRANSLATIONS = {
  "Full Request Parameters": "完整请求参数",
  "Request Parameters": "请求参数",
  "Request Payload": "请求参数",
  "Request JSON": "请求 JSON",
  "Response Content": "返回内容",
  "Response JSON": "返回 JSON",
  "Final Submit": "最终提交",
  "System Prompt": "系统提示词",
  "SYSTEM PROMPT": "系统提示词",
  "Copy Video Prompt": "复制视频提示词",
  "Copy Prompt": "复制提示词",
  "Export JSON": "导出 JSON",
  "Copy JSON": "复制 JSON",
  "Asset Group": "素材组",
  "Voice ID": "音色 ID",
  "Project ID": "项目 ID",
  "Episode ID": "集 ID",
  "Provider": "供应商",
  "Prompt": "提示词",
  "Payload": "传参",
  "Response": "返回内容",
  "Route": "线路",
  "Model": "模型",
  "Status": "状态",
  "Actions": "操作",
  "Agent Task": "智能体任务",
  "Agent": "智能体",
  "Empty": "空",
  "EMPTY": "空",
  "Loading": "加载中",
  "Error": "错误",
  "Success": "成功",
  "Warning": "警告",
  "Failed": "失败",
  "Pending": "待处理",
  "Completed": "已完成",
  "Generated": "已生成",
  "BGM": "背景音乐",
};

const applyPatternTranslations = (source, patterns, options = {}) => {
  const translateChineseFragments = options.translateChineseFragments !== false;
  for (const [pattern, replacement] of patterns) {
    if (!pattern.test(source)) continue;
    const translated = source.replace(pattern, replacement);
    return translateChineseFragments && /[\u4e00-\u9fff]/.test(translated)
      ? translateShortUiFragments(translated) || translated
      : translated;
  }
  return null;
};

const restoreShortUiFragments = (source) => {
  if (source.length > 60) return null;
  if (/[\n\r]/.test(source)) return null;
  if (/https?:\/\//i.test(source)) return null;
  let translated = source;
  Object.entries(UI_FRAGMENT_RESTORE_TRANSLATIONS)
    .sort((a, b) => b[0].length - a[0].length)
    .forEach(([en, zh]) => {
      translated = translated.replaceAll(en, zh);
    });
  translated = translated
    .replace(/([\u4e00-\u9fff])\s+([\u4e00-\u9fff])/g, "$1$2")
    .replace(/[ \t]{2,}/g, " ")
    .trim();
  return translated !== source ? translated : null;
};

const translateShortUiFragments = (source) => {
  if (source.length > 42) return null;
  if (/[\n\r]/.test(source)) return null;
  if ((source.match(/[，。；！？、]/g) || []).length > 1) return null;
  let translated = source;
  Object.entries(UI_FRAGMENT_TRANSLATIONS)
    .sort((a, b) => b[0].length - a[0].length)
    .forEach(([zh, en]) => {
      translated = translated.replaceAll(zh, en);
    });
  translated = translated
    .replaceAll("：", ": ")
    .replaceAll("，", ", ")
    .replaceAll("。", ".")
    .replaceAll("！", "!")
    .replaceAll("？", "?")
    .replaceAll("、", ", ")
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .replace(/([.!?])([A-Z])/g, "$1 $2")
    .replace(/[ \t]{2,}/g, " ")
    .trim();
  return translated !== source ? translated : null;
};

const preserveEdgeWhitespace = (source, translated) => {
  const prefix = source.match(/^\s*/)?.[0] || "";
  const suffix = source.match(/\s*$/)?.[0] || "";
  return `${prefix}${translated}${suffix}`;
};

export const translateUiText = (value, language) => {
  if (value == null) return value;
  const source = String(value);
  const trimmed = source.trim();
  if (!trimmed) return source;
  if (language === LANGUAGE_EN) {
    const translated = UI_TRANSLATIONS[trimmed];
    if (translated) return preserveEdgeWhitespace(source, translated);
    const patterned = applyPatternTranslations(trimmed, UI_TRANSLATION_PATTERNS);
    if (patterned) return preserveEdgeWhitespace(source, patterned);
    const fragmented = translateShortUiFragments(trimmed);
    return fragmented ? preserveEdgeWhitespace(source, fragmented) : source;
  }
  const restored = UI_TRANSLATIONS_REVERSE[trimmed];
  if (restored) return preserveEdgeWhitespace(source, restored);
  const patterned = applyPatternTranslations(trimmed, UI_RESTORE_PATTERNS, { translateChineseFragments: false });
  if (patterned) return preserveEdgeWhitespace(source, patterned);
  const fragmented = restoreShortUiFragments(trimmed);
  return fragmented ? preserveEdgeWhitespace(source, fragmented) : source;
};
